import { getStudyClinics } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from './use-current-user';
export function useStudyClinics() {
    const { currentUser } = useCurrentUser();
    return useQuery({
        queryKey: ['studyClinics'],
        queryFn: getStudyClinics,
        staleTime: 5 * 60 * 1000, // 5 minutes
        enabled: !!currentUser,
    });
}
/**
 * Returns whether the clinic filter dropdown should be shown.
 * Shows if user is a super admin OR has access to multiple clinics.
 */
export function useShowClinicFilter() {
    const { data: clinics } = useStudyClinics();
    const { isSuperAdmin } = useCurrentUser();
    return isSuperAdmin || (clinics?.length ?? 0) > 1;
}
